import { selector } from 'recoil';
import { timeSavedMetric } from '../atoms/timeSavedMetric';
import { currentTeam } from '../atoms/currentTeam';
import { timeSaved } from './timeSaved';

export const timeSavedChartOptions = selector({
  key: 'timeSavedChartOptions',
  get: ({ get }) => {
    try {
      const result = {};
      const current = get(timeSavedMetric);
      const timeSavedReport = get(timeSaved);
      const team = get(currentTeam);
      const categoryArr = [];
      const seriesArr = [];
      const options = {
        chart: {
          height: 650,
          type: 'bar',
        },
        plotOptions: {
          series: {
            animation: {
              duration: 2000,
            },
          },
        },
        series: [
          {
            dataSorting: {
              enabled: true,
            },
            name: '',
            data: [],
          },
        ],
        title: {
          text: team.id
            ? `Time Saved (In Minutes) - ${team.name}`
            : 'Time Saved (In Minutes)',
        },
        xAxis: {
          categories: [],
        },
        credits: {
          enabled: false,
        },
        yAxis: {
          crosshair: {
            width: 1,
            color: 'blue',
          },
          labels: {
            enabled: true,
          },
          title: {
            text: current.title,
          },
        },
      };
      const editableStats = JSON.parse(JSON.stringify(timeSavedReport.charts));
      editableStats.sort(
        (a, b) => b.totals[current.key] - a.totals[current.key]
      );
      editableStats.forEach((i) => {
        if (i.totals[current.key] && i.totals.email) {
          categoryArr.push(i.totals.email);
          seriesArr.push(i.totals[current.key]);
        }
      });
      result.options = options;
      result.options.xAxis.categories = categoryArr;
      result.options.series[0].data = seriesArr;
      return result;
    } catch (error) {
      throw error;
    }
  },
});
